import React from 'react'
import NavBar from '../NavBar'
import NavBarTop from "../NavBarTop.js"
import { CenterContact } from '../components/CenterContact'
import Footer from '../components/Footer'
import env from '../config';
import { useLocation } from 'react-router-dom';
let urlMedia = env.url

const MensajePqrs = () => {

  const location = useLocation();

  // Parsea los parámetros de la consulta
  const queryParams = new URLSearchParams(location.search);
  const numeroSolicitud = queryParams.get('numeroSolicitud');

  console.log(numeroSolicitud);
  return (
    <>
    {/* <NavBar /> */}
    <NavBarTop/>
    <div className="mensaje">
        <div>
        <p>Gracias por contactarnos, su solicitud esta siendo procesada y su número es: 
        </p>
        <br />
        <p className='numSoli'>
            {numeroSolicitud}
        </p>

        <br />
        <p>
            Muy pronto uno de nuestros asesores se comunicará con usted.
        </p>
        </div>
        <img src={urlMedia + "mensaje.webp"} className="fotoGracias" />
    </div>
    <CenterContact /> 
    <Footer />
    </>
  )
}

export default MensajePqrs